module.exports = __webpack_public_path__ + "img/house-door-fill.f0422182.svg";